import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { useSEO } from '@/hooks/useSEO';
import { siteInfo } from '@/mocks/site';

const aboutSeo = {
  title: '关于我们 - 黑料吃瓜网 | 品牌介绍与联系方式',
  description:
    '了解黑料吃瓜网——国内领先的娱乐八卦资讯聚合平台。我们提供品牌介绍、口碑评价和联系方式，致力于为用户提供最新最全的吃瓜爆料内容。',
  keywords: '黑料吃瓜网,关于我们,品牌介绍,联系方式,吃瓜平台',
  canonical: 'https://www.heiliaochigua.com/about',
};

export default function About() {
  useSEO(aboutSeo);

  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypot = form.querySelector<HTMLInputElement>('input[name="company_alt"]');
    if (honeypot && honeypot.value.trim() !== '') {
      setFormStatus('success');
      form.reset();
      return;
    }

    setIsSubmitting(true);
    setFormError('');

    try {
      const submitAddr = 'https://readdy.ai/api/form/d96a09ltfb6ioa7s1lrg';

      const formData = new FormData(form);
      const payload = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'company_alt') {
          payload.append(key, value.toString());
        }
      });

      const response = await fetch(submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg =
          parsed?.meta?.message || parsed?.message || responseText || '提交失败，请重试';
        setFormError(serverMsg);
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请稍后重试');
      setFormStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const faqQuestions = [
    {
      question: '黑料吃瓜网是什么？',
      answer:
        '黑料吃瓜网是国内领先的娱乐八卦资讯聚合平台，聚焦91黑料吃瓜网、黑料吃瓜在线观看等热门搜索词，为网友提供最新、最全的网红塌房实录、明星八卦、直播翻车等吃瓜爆料内容。',
    },
    {
      question: '如何获取最新的吃瓜内容？',
      answer:
        '您可以直接访问黑料吃瓜网首页，我们的团队24小时不间断更新最新爆料内容。您也可以关注首页的热门话题标签，快速找到感兴趣的内容分类。',
    },
    {
      question: '黑料吃瓜网的内容是否真实可靠？',
      answer:
        '我们致力于为读者提供真实可靠的娱乐资讯。所有内容均来源于公开报道和网友投稿，我们会对信息进行多方核实后再发布。同时，我们也建议读者理性看待网络信息，保持独立思考。',
    },
    {
      question: '如何联系黑料吃瓜网？',
      answer:
        '您可以通过本页面的联系表单与我们取得联系，也可以直接发送邮件至 contact@heiliaochigua.com。我们会在收到信息后尽快回复。',
    },
    {
      question: '黑料吃瓜网是否接受投稿？',
      answer:
        '我们欢迎网友提供爆料线索和投稿。您可以通过联系表单或邮件的方式向我们提交内容。对于质量较高的独家爆料，我们会标注投稿人信息并给予相应的展示位置。',
    },
  ];

  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '关于我们 - 黑料吃瓜网',
          description: aboutSeo.description,
          url: aboutSeo.canonical,
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{ questions: faqQuestions }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="max-w-4xl mx-auto px-4 md:px-6 pt-24 pb-20">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="mb-16">
            <h1 className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 mb-4">
              关于我们
            </h1>
            <p className="text-foreground-600 leading-relaxed max-w-2xl">
              {siteInfo.description}
            </p>
          </section>

          <section className="mb-16">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-6">
              品牌介绍
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              <div className="p-6 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 mb-4">
                  <i className="ri-fire-line text-lg text-primary-600"></i>
                </div>
                <h3 className="font-bold text-foreground-900 mb-2">独家内容</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  汇聚全网最新最热的娱乐爆料，为用户提供独家吃瓜资源，24小时不间断更新。
                </p>
              </div>
              <div className="p-6 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 mb-4">
                  <i className="ri-speed-line text-lg text-accent-600"></i>
                </div>
                <h3 className="font-bold text-foreground-900 mb-2">极速更新</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  专业的编辑团队实时跟踪热点事件，确保用户第一时间获取最新的吃瓜资讯。
                </p>
              </div>
              <div className="p-6 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 mb-4">
                  <i className="ri-shield-check-line text-lg text-secondary-600"></i>
                </div>
                <h3 className="font-bold text-foreground-900 mb-2">真实可信</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  坚持内容真实性原则，多方核实信息来源，为用户提供经得起推敲的爆料内容。
                </p>
              </div>
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-6">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              <div className="p-6 rounded-lg bg-background-100/70 border border-background-200/70">
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm text-accent-500"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  "吃瓜速度太快了！每次有大事发生，这里都是第一个更新的，已经安利给所有朋友了。"
                </p>
                <p className="text-xs text-foreground-400 font-medium">—— 资深吃瓜群众</p>
              </div>
              <div className="p-6 rounded-lg bg-background-100/70 border border-background-200/70">
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm text-accent-500"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  "内容分类很清晰，想看的类型都能快速找到。页面也很简洁，没有乱七八糟的广告，体验很好。"
                </p>
                <p className="text-xs text-foreground-400 font-medium">—— 娱乐八卦爱好者</p>
              </div>
              <div className="p-6 rounded-lg bg-background-100/70 border border-background-200/70">
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm text-accent-500"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  "24小时不打烊是真的！凌晨三点刷到新料，比热搜还快，真·吃瓜第一线。"
                </p>
                <p className="text-xs text-foreground-400 font-medium">—— 熬夜吃瓜达人</p>
              </div>
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-6">
              常见问题
            </h2>
            <div className="space-y-3">
              {faqQuestions.map((faq, index) => (
                <details
                  key={index}
                  className="group rounded-lg bg-background-50 border border-background-200/70"
                >
                  <summary className="flex items-center justify-between p-5 cursor-pointer">
                    <span className="text-sm font-medium text-foreground-900 pr-4">
                      {faq.question}
                    </span>
                    <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-180 transition-transform">
                      <i className="ri-arrow-down-s-line"></i>
                    </span>
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-6">
              联系我们
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
              <div className="lg:col-span-2 space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                    <i className="ri-mail-line text-primary-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">电子邮箱</p>
                    <a
                      href={`mailto:${siteInfo.email}`}
                      className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                      rel="nofollow"
                    >
                      {siteInfo.email}
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                    <i className="ri-time-line text-accent-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">工作时间</p>
                    <p className="text-sm text-foreground-500">7×24小时在线服务</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100 flex-shrink-0">
                    <i className="ri-chat-smile-2-line text-secondary-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">商务合作</p>
                    <p className="text-sm text-foreground-500">请通过邮件联系</p>
                  </div>
                </div>
              </div>

              <div className="lg:col-span-3">
                <form
                  onSubmit={handleSubmit}
                  className="p-6 rounded-lg bg-background-50 border border-background-200/70"
                  data-readdy-form=""
                  id="contact-form"
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        姓名
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200/70 bg-background-50 text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        邮箱
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200/70 bg-background-50 text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                  </div>
                  <div className="mb-4">
                    <label htmlFor="subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      主题
                    </label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      required
                      className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200/70 bg-background-50 text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all"
                      placeholder="请输入主题"
                    />
                  </div>
                  <div className="mb-4">
                    <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      留言内容
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      rows={4}
                      maxLength={500}
                      required
                      className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200/70 bg-background-50 text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all resize-none"
                      placeholder="请输入您的留言（最多500字）"
                    ></textarea>
                    <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
                  </div>

                  <input
                    type="text"
                    name="company_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="form-honeypot"
                  />

                  {formStatus === 'success' && (
                    <div className="mb-4 p-3 rounded-lg bg-primary-50 border border-primary-200">
                      <p className="text-sm text-primary-700">提交成功！我们会尽快与您联系。</p>
                    </div>
                  )}
                  {formStatus === 'error' && (
                    <div className="mb-4 p-3 rounded-lg bg-accent-50 border border-accent-200">
                      <p className="text-sm text-accent-700">{formError || '提交失败，请重试'}</p>
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full sm:w-auto px-8 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                  >
                    {isSubmitting ? (
                      <>
                        <i className="ri-loader-4-line animate-spin mr-2"></i>
                        提交中...
                      </>
                    ) : (
                      '发送留言'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}